import './SwitchWithLabel.scss';
import { Switch } from '@trackman/web-shared-components';
import { BaseSyntheticEvent } from 'react';

type Props = {
  value: boolean;
  header: string;
  description: string;
  setValue: (newValue: boolean) => void;
};

export const SwitchWithLabel = ({ value, header, description, setValue }: Props) => {
  return (
    <div className='switch-with-label'>
      <Switch label='' checked={value} onChange={(e: BaseSyntheticEvent) => setValue(e.target.checked)} />
      <div className='switch-label'>
        <div>{header}</div>
        <div>{description}</div>
      </div>
    </div>
  );
};
